export default __webpack_public_path__ + "static/media/plan-fact.6a23d5a3.svg";